module.exports = __webpack_public_path__ + "static/media/anniversary.b56bd5fb.png";